import phoneIcon from "../../../assets/Form/phone1.svg";

export default function CallButton({ children, onClick, eyebrow = "START TODAY" }) {
  return (
    <a href={onClick ? "#insurance-form" : "tel:8882021350"} onClick={onClick} className="inline-flex items-center rounded-full bg-[#F8D216] px-3 py-2">
      <span className="flex h-9 w-9 items-center justify-center rounded-full bg-[#1C2D8C]"><img src={phoneIcon} alt="" className="h-4 w-4" /></span>
      <span className="ml-3 text-left font-lato font-bold text-[#162766]"><small className="block text-[10px] tracking-wide">{eyebrow}</small><span className="block text-[16px] leading-5">{children}</span></span>
    </a>
  );
}
